import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { painPoints } from '../data/content';
export function ProblemSection() {
  return <section className="w-full bg-surface px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="problema-title" data-id="element-226" data-mp="30h7nzw0x86xq">
      <div className="mx-auto max-w-5xl" data-id="element-227" data-mp="2vq7nyhwi98r0">
        <SectionHeading title="¿Cuántos domingos más vas a esperar así?" align="center" data-id="element-228" data-mp="2vp6dofnbcqac" />
        <div className="mx-auto mt-8 max-w-3xl space-y-5 text-center" data-id="element-229" data-mp="39jqnc65i01f8">
          <p className="text-base leading-relaxed text-neutral-400 sm:text-lg" data-id="element-230" data-mp="35frca32zlut9">
            Querés definir. Querés bajar grasa. Querés un abdomen más marcado.
            Pero nadie te dijo que ibas a pasar cada domingo armando rutinas que
            no funcionan, pesando comida al gramo y llegando a la próxima semana
            destruido, sin resultados y a punto de abandonar.
          </p>
          <p id="problema-title" className="text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-id="element-231" data-mp="1k4ismn3cht2n">
            No es falta de disciplina. Es falta de un sistema.
          </p>
        </div>

        <p className="mt-12 text-sm font-extrabold uppercase tracking-[0.18em] text-ember" data-id="element-232" data-mp="sdtf3fi5vfzc">
          El problema real
        </p>

        <ul className="mt-5 grid gap-3 md:grid-cols-2" data-id="element-233" data-mp="x4rwyjissm4p">
          {painPoints.map(point => <li key={point.title} className="flex items-start gap-3 rounded-2xl border border-line bg-ink p-5" data-id="element-234" data-mp="124e9srups0cz">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ember/15" aria-hidden="true" data-id="element-235" data-mp="174shu9wbfab0">
                <XIcon className="h-3.5 w-3.5 text-ember" data-id="element-236" data-mp="1g2l11p55r23o" />
              </span>
              <div data-id="element-237" data-mp="3dugxdbwejwqc">
                <h3 className="text-base font-extrabold leading-snug tracking-tight text-white" data-id="element-238" data-mp="3duypbwc17osg">
                  {point.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-neutral-400" data-id="element-239" data-mp="ozqwg721tnvj">
                  {point.description}
                </p>
              </div>
            </li>)}
        </ul>

        <p className="mt-12 text-center text-2xl font-extrabold leading-tight tracking-tight text-gold sm:text-4xl" data-id="element-240" data-mp="y1gnhbs0qkss">
          ¿Y si este fuera el último domingo que gastás así?
        </p>
      </div>
    </section>;
}